module.exports = __webpack_public_path__ + "static/media/reimbursed.e60df34c.png";